import { Directive, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[TableColumnSort]',
})
export class TableColumnSortDirective {
  @Input() data: any[] = [];
  @Input() field!: string;
  @Input() ref?: any;
  @Input() fieldTwo?: string;

  private sortField = '';
  private sortDirection: 'asc' | 'desc' | '' = '';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click')
  onClick() {
    // Remove arrows from other headers
    this.clearOtherIndicators();

    // Perform sorting + update arrow
    this.sortTableBy(this.field, this.ref, this.fieldTwo);
    this.updateIndicator();
  }

  private sortTableBy(field: string, ref?: any, fieldTwo?: string) {
    if (this.sortField === field) {
      this.sortDirection =
        this.sortDirection === 'asc' ? 'desc' : this.sortDirection === 'desc' ? '' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }

    // If direction cleared → don't sort
    if (this.sortDirection === '') return;

    this.data.sort((a, b) => {
      let aValue: any, bValue: any;

      if (ref) {
        aValue = this.getNestedValue(a, field, ref, fieldTwo);
        bValue = this.getNestedValue(b, field, ref, fieldTwo);
      } else {
        aValue = this.getNestedValue(a, field);
        bValue = this.getNestedValue(b, field);
      }

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return this.sortDirection === 'asc' ? 1 : -1;
      if (bValue == null) return this.sortDirection === 'asc' ? -1 : 1;

      if (!isNaN(aValue) && !isNaN(bValue)) {
        return this.sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
      }

      aValue = String(aValue).toLowerCase();
      bValue = String(bValue).toLowerCase();

      return this.sortDirection === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    });
  }

  private getNestedValue(obj: any, path: string, ref?: string, pathTwo?: string): any {
    if (ref) {
      return path.split('.').reduce((acc, key) => acc[key] && ref[acc[key]][pathTwo], obj);
    } else {
      return path.split('.').reduce((acc, key) => acc[key], obj);
    }
  }

  private updateIndicator() {
    const th = this.el.nativeElement as HTMLElement;

    // Remove old arrow if exists
    const existingArrow = th.querySelector('.sort-arrow');
    if (existingArrow) {
      this.renderer.removeChild(th, existingArrow);
    }

    // Remove highlight
    this.renderer.removeClass(th, 'text-blue-600');
    this.renderer.removeClass(th, 'font-semibold');

    // If unsorted, no arrow
    if (this.sortDirection === '') return;

    // Add highlight
    this.renderer.addClass(th, 'text-blue-600');
    this.renderer.addClass(th, 'font-semibold');

    // Create arrow
    const arrow = this.renderer.createElement('span');
    this.renderer.addClass(arrow, 'sort-arrow');
    this.renderer.addClass(arrow, 'ml-1');
    this.renderer.addClass(arrow, 'text-xs');
    arrow.textContent = this.sortDirection === 'asc' ? '▲' : '▼';
    this.renderer.appendChild(th, arrow);
  }

  private clearOtherIndicators() {
    // Get all headers with the directive
    const allHeaders = document.querySelectorAll('[TableColumnSort]');
    allHeaders.forEach((el) => {
      if (el !== this.el.nativeElement) {
        const arrow = el.querySelector('.sort-arrow');
        if (arrow) arrow.remove();
        el.classList.remove('text-blue-600', 'font-semibold');
      }
    });
  }
}
